import BulkActionsConfirmActionStepInlineConfirmation from "components/BulkActions/ConfirmActionStep/InlineConfirmation";

import { UserRolesBulkActionsConfirmActionStepProps } from "./types";

type UserRolesBulkActionsConfirmActionStepDefaultProps = UserRolesBulkActionsConfirmActionStepProps;

const UserRolesBulkActionsConfirmActionStepDefault = ({
  action,
  bulkActionsVariant,
  onConfirm,
  onCancel,
  customConfirmationMessage,
}: UserRolesBulkActionsConfirmActionStepDefaultProps) => {
  return (
    <BulkActionsConfirmActionStepInlineConfirmation
      variant={bulkActionsVariant}
      actionLabel={action.title.toLowerCase()}
      onConfirm={() =>
        onConfirm(null, {
          view: bulkActionsVariant,
          metadata: {},
        })
      }
      onCancel={onCancel}
      customConfirmationMessage={customConfirmationMessage}
    />
  );
};

export default UserRolesBulkActionsConfirmActionStepDefault;
